import { render, staticRenderFns } from "./RecFooter.vue?vue&type=template&id=5a5abf1c&"
import script from "./RecFooter.vue?vue&type=script&lang=js&"
export * from "./RecFooter.vue?vue&type=script&lang=js&"
import style0 from "./RecFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports